// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Menu Categories Component Styles */
.menu-categories {
  padding: 80px 0;
  background: #f8f9fa;
  position: relative;
}

.menu-categories__container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.menu-categories__header {
  text-align: center;
  margin-bottom: 60px;
}

.menu-categories__title {
  font-size: clamp(32px, 4vw, 48px);
  font-weight: 300;
  color: #2c3e50;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 3px;
  position: relative;
}

.menu-categories__title::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: linear-gradient(135deg, #4FC3F7 0%, #29B6F6 100%);
  border-radius: 2px;
}

.menu-categories__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  align-items: stretch;
}

.menu-category {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 
    0 10px 30px rgba(0, 0, 0, 0.1),
    0 1px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.4s ease;
  position: relative;
  cursor: pointer;
}

.menu-category:hover {
  transform: translateY(-8px);
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.15),
    0 10px 20px rgba(0, 0, 0, 0.1);
}

.menu-category__image-wrapper {
  position: relative;
  height: 250px;
  overflow: hidden;
}

.menu-category__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: transform 0.4s ease;
}

.menu-category:hover .menu-category__image {
  transform: scale(1.05);
}

.menu-category__overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    45deg,
    rgba(0, 0, 0, 0.3) 0%,
    rgba(0, 0, 0, 0.1) 50%,
    rgba(79, 195, 247, 0.2) 100%
  );
  opacity: 0;
  transition: opacity 0.3s ease;
}

.menu-category:hover .menu-category__overlay {
  opacity: 1;
}

.menu-category__content {
  padding: 30px 25px;
  text-align: center;
}

.menu-category__name {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 10px 0;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.menu-category__description {
  font-size: 14px;
  color: #64748b;
  margin: 0 0 20px 0;
  line-height: 1.5;
}

.menu-category__button {
  background: transparent;
  color: #4FC3F7;
  border: 2px solid #4FC3F7;
  padding: 10px 25px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 5px;
  text-decoration: none;
  display: inline-block;
}

.menu-category__button:hover {
  background: #4FC3F7;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(79, 195, 247, 0.4);
}

/* Mobile Responsive */
@media (max-width: 1024px) {
  .menu-categories {
    padding: 60px 0;
  }

  .menu-categories__container {
    padding: 0 15px;
  }

  .menu-categories__header {
    margin-bottom: 40px;
  }

  .menu-categories__grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }

  .menu-category__image-wrapper {
    height: 200px;
  }

  .menu-category__content {
    padding: 25px 20px;
  }

  .menu-category__name {
    font-size: 20px;
  }
}

@media (max-width: 1200px) {
  .menu-categories__grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }
}

@media (max-width: 768px) {
  .menu-categories {
    padding: 50px 0;
  }

  .menu-categories__grid {
    grid-template-columns: 1fr;
    gap: 20px;
    max-width: 400px;
    margin: 0 auto;
  }

  .menu-category {
    border-radius: 15px;
  }

  .menu-category__image-wrapper {
    height: 180px;
  }

  .menu-category__content {
    padding: 20px 15px;
  }

  .menu-category__name {
    font-size: 18px;
    letter-spacing: 1px;
  }

  .menu-category__description {
    font-size: 13px;
  }

  .menu-category__button {
    padding: 8px 20px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .menu-categories__container {
    padding: 0 10px;
  }

  .menu-categories__title {
    font-size: clamp(24px, 8vw, 36px);
    letter-spacing: 2px;
  }

  .menu-category__content {
    padding: 15px 12px;
  }
}

/* Animation for scroll reveal */
.menu-category {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeInUp 0.6s ease forwards;
}

.menu-category:nth-child(1) {
  animation-delay: 0.1s;
}

.menu-category:nth-child(2) {
  animation-delay: 0.2s;
}

.menu-category:nth-child(3) {
  animation-delay: 0.3s;
}

.menu-category:nth-child(4) {
  animation-delay: 0.4s;
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Hover effects for better interaction */
.menu-category::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(79, 195, 247, 0.1) 0%, rgba(41, 182, 246, 0.1) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  border-radius: 20px;
}

.menu-category:hover::before {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/MenuCategories.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB;;iCAE+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B;;kCAEgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;GAKC;EACD,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,gCAAgC;AAChC;EACE,UAAU;EACV,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6FAA6F;EAC7F,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/* Menu Categories Component Styles */\n.menu-categories {\n  padding: 80px 0;\n  background: #f8f9fa;\n  position: relative;\n}\n\n.menu-categories__container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.menu-categories__header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.menu-categories__title {\n  font-size: clamp(32px, 4vw, 48px);\n  font-weight: 300;\n  color: #2c3e50;\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 3px;\n  position: relative;\n}\n\n.menu-categories__title::after {\n  content: '';\n  position: absolute;\n  bottom: -15px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80px;\n  height: 3px;\n  background: linear-gradient(135deg, #4FC3F7 0%, #29B6F6 100%);\n  border-radius: 2px;\n}\n\n.menu-categories__grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 30px;\n  align-items: stretch;\n}\n\n.menu-category {\n  background: white;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: \n    0 10px 30px rgba(0, 0, 0, 0.1),\n    0 1px 8px rgba(0, 0, 0, 0.06);\n  transition: all 0.4s ease;\n  position: relative;\n  cursor: pointer;\n}\n\n.menu-category:hover {\n  transform: translateY(-8px);\n  box-shadow: \n    0 20px 40px rgba(0, 0, 0, 0.15),\n    0 10px 20px rgba(0, 0, 0, 0.1);\n}\n\n.menu-category__image-wrapper {\n  position: relative;\n  height: 250px;\n  overflow: hidden;\n}\n\n.menu-category__image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  transition: transform 0.4s ease;\n}\n\n.menu-category:hover .menu-category__image {\n  transform: scale(1.05);\n}\n\n.menu-category__overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    45deg,\n    rgba(0, 0, 0, 0.3) 0%,\n    rgba(0, 0, 0, 0.1) 50%,\n    rgba(79, 195, 247, 0.2) 100%\n  );\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.menu-category:hover .menu-category__overlay {\n  opacity: 1;\n}\n\n.menu-category__content {\n  padding: 30px 25px;\n  text-align: center;\n}\n\n.menu-category__name {\n  font-size: 24px;\n  font-weight: 600;\n  color: #2c3e50;\n  margin: 0 0 10px 0;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n}\n\n.menu-category__description {\n  font-size: 14px;\n  color: #64748b;\n  margin: 0 0 20px 0;\n  line-height: 1.5;\n}\n\n.menu-category__button {\n  background: transparent;\n  color: #4FC3F7;\n  border: 2px solid #4FC3F7;\n  padding: 10px 25px;\n  border-radius: 25px;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 5px;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.menu-category__button:hover {\n  background: #4FC3F7;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(79, 195, 247, 0.4);\n}\n\n/* Mobile Responsive */\n@media (max-width: 1024px) {\n  .menu-categories {\n    padding: 60px 0;\n  }\n\n  .menu-categories__container {\n    padding: 0 15px;\n  }\n\n  .menu-categories__header {\n    margin-bottom: 40px;\n  }\n\n  .menu-categories__grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 25px;\n  }\n\n  .menu-category__image-wrapper {\n    height: 200px;\n  }\n\n  .menu-category__content {\n    padding: 25px 20px;\n  }\n\n  .menu-category__name {\n    font-size: 20px;\n  }\n}\n\n@media (max-width: 1200px) {\n  .menu-categories__grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 25px;\n  }\n}\n\n@media (max-width: 768px) {\n  .menu-categories {\n    padding: 50px 0;\n  }\n\n  .menu-categories__grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n    max-width: 400px;\n    margin: 0 auto;\n  }\n\n  .menu-category {\n    border-radius: 15px;\n  }\n\n  .menu-category__image-wrapper {\n    height: 180px;\n  }\n\n  .menu-category__content {\n    padding: 20px 15px;\n  }\n\n  .menu-category__name {\n    font-size: 18px;\n    letter-spacing: 1px;\n  }\n\n  .menu-category__description {\n    font-size: 13px;\n  }\n\n  .menu-category__button {\n    padding: 8px 20px;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .menu-categories__container {\n    padding: 0 10px;\n  }\n\n  .menu-categories__title {\n    font-size: clamp(24px, 8vw, 36px);\n    letter-spacing: 2px;\n  }\n\n  .menu-category__content {\n    padding: 15px 12px;\n  }\n}\n\n/* Animation for scroll reveal */\n.menu-category {\n  opacity: 0;\n  transform: translateY(30px);\n  animation: fadeInUp 0.6s ease forwards;\n}\n\n.menu-category:nth-child(1) {\n  animation-delay: 0.1s;\n}\n\n.menu-category:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.menu-category:nth-child(3) {\n  animation-delay: 0.3s;\n}\n\n.menu-category:nth-child(4) {\n  animation-delay: 0.4s;\n}\n\n@keyframes fadeInUp {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Hover effects for better interaction */\n.menu-category::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(79, 195, 247, 0.1) 0%, rgba(41, 182, 246, 0.1) 100%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n  border-radius: 20px;\n}\n\n.menu-category:hover::before {\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
